// usePrepareJobData.js
// Prepare the data to create a job for firebase

import { useSelector } from 'react-redux';
import gymJobTemplate from '/public/data/gym/gymJob.json';

const usePrepareJobData = () => {
  const basketID = useSelector((state) => state.basket.basketData.basketID);
  const gymData = useSelector((state) => state.gym);

  const prepareJobData = () => ({
    ...gymJobTemplate,
    basketID,
    jobType: gymData.serviceOpt,
    fittings: gymData.fittings,
    initialDate: new Date().toISOString(),
    optimoDates: gymData.optimoDates,
    mirrors: {
      largeQty: gymData.largeQty,
      XLQty: gymData.XLQty,
      XXLQty: gymData.XXLQty,
      bespoke: gymData.bespokeMirrors,
    },
  });

  return { prepareJobData };
};

export default usePrepareJobData;
